import { getAcademicPerformanceLabel } from "./profileHelpers";
const TOOLTIP_LIST_ITEM_MAX_LENGTH = 50;
const paymentMethodTypeLabels = {
    credit_card: 'Cartão de Crédito',
    pix: 'Pix',
    bank_slip: 'Boleto Bancário',
    boleto_pix: 'Boleto ou Pix'
};
export const formatPaymentMethodType = (type) => {
    return paymentMethodTypeLabels[type] || type;
};
const installmentTypeLabels = {
    entry: 'Entrada',
    remaining: 'Mensalidade'
};
export const formatInstallmentType = (type) => {
    return installmentTypeLabels[type] || type;
};
const installmentStatusFilterLabels = {
    pending: 'Parcelas pendentes',
    overdue: 'Parcelas vencidas',
    paid: 'Parcelas pagas'
};
export const formatInstallmentStatusFilter = (statusFilter) => {
    return installmentStatusFilterLabels[statusFilter] || statusFilter;
};
export const convertSecondsToHour = (timeInSeconds, typeToConvert, typeReturn) => {
    let minutesText = 'Minutos';
    let hoursText = 'Horas';
    let minutes = 0;
    let hour = 0;
    switch (typeToConvert) {
        case 'H-i':
            minutes = parseInt((timeInSeconds / 60).toFixed(0));
            if (minutes >= 60) {
                hour = parseFloat((minutes / 60).toFixed(2));
                const hourMinutes = hour - Math.trunc(hour);
                let convertToMinutes = hourMinutes * 60;
                hour === 1 && (hoursText = 'Horas');
                hourMinutes === 1 && (minutesText === 'Minuto');
                return typeReturn === 'returnText' ?
                    `${Math.trunc(hour)} ${hoursText} e ${parseInt(convertToMinutes.toFixed(0))} ${minutesText}`
                    : hour;
            }
            minutes === 1 && (minutesText = 'Minuto');
            return `${minutes} ${minutesText}`;
        case 'H':
            minutes = timeInSeconds / 60;
            hour = parseFloat((minutes / 60).toFixed(2));
            hour === 1 && (hoursText = 'Hora');
            return typeReturn === 'returnText' ?
                `${hour} ${hoursText}` :
                hour;
        case 'i':
            minutes = parseInt((timeInSeconds / 60).toFixed(0));
            minutes === 1 && (minutesText = 'Minuto');
            return typeReturn === 'returnText' ?
                `${minutes} ${minutesText}`
                : minutes;
    }
};
export const getBadgesToolTipData = (badgeObject) => {
    return `<p style="text-align: left"><strong>${badgeObject?.name || "Badge Title"}</strong> <br> ${badgeObject?.description || "Badge Description"}</p>`;
};
export const getPodiumToolTipData = (podiumStudent) => {
    const weeklyTimeText = convertSecondsToHour(podiumStudent?.weekly_hours ?? 0, 'H-i', 'returnText');
    return `<p style="text-align: left"><strong>${podiumStudent?.name || 'Estudante'}</strong> <br> ${weeklyTimeText} na semana</p>`;
};
export const getEnrollmentsToolTipData = (enrollments) => {
    if (!Array.isArray(enrollments) || enrollments.length === 0)
        return 'Nenhuma matrícula encontrada';
    const listItems = enrollments.map((enrollment) => {
        const courseName = enrollment?.course?.name
            || enrollment?.curriculum?.course?.name
            || enrollment?.classroom?.course?.name
            || 'Curso sem nome';
        const formattedName = courseName.length > TOOLTIP_LIST_ITEM_MAX_LENGTH
            ? `${courseName.substring(0, TOOLTIP_LIST_ITEM_MAX_LENGTH)}...`
            : courseName;
        return `<li>${formattedName}</li>`;
    }).join('');
    return `<ul>${listItems}</ul>`;
};
export const getAcademicPerformanceToolTipData = (performance) => {
    return `<p style="text-align: left"><strong>Status:</strong> ${getAcademicPerformanceLabel(performance?.percentage)}</p>`;
};
export const removeOuterParagraphTags = (htmlContent) => {
    const regex = /^<p>(.*?)<\/p>$/;
    const match = htmlContent.match(regex);
    if (match) {
        return match[1];
    }
    return htmlContent;
};
export const removeTagsThatBreakLine = (htmlContent) => {
    return htmlContent
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/?(p|ul|ol|li|div)[^>]*>/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
};
export const convertToDateFromBr = (dateStr) => {
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");
    return new Date(year, month - 1, day, hours, minutes);
};
export const formatDateToDDMMYYYYHHMI = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês é 0-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
};
export const formatDateToDDMMYYYY = (dateValue) => {
    if (!dateValue)
        return '-';
    const date = new Date(dateValue);
    if (isNaN(date.getTime()))
        return '-';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};
export const formatTimeToHHMI = (dateValue) => {
    if (!dateValue)
        return '-';
    const date = new Date(dateValue);
    if (isNaN(date.getTime()))
        return '-';
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};
export const formatSensitiveInformation = (information) => {
    if (!information || typeof information !== 'string')
        return '********';
    return `${information.slice(0, 4)}****`;
};
export const formatCamelToSnakeCase = (value) => {
    return value.replace(/([A-Z])/g, '_$1').toLowerCase();
};
export const formatCurrency = (amount) => {
    const value = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (value == null || isNaN(value))
        return 'R$ 0,00';
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
export const decimalMask = ['#,##', '##,##', '###,##', '####,##', '#####,##', '######,##', '#######,##'];
export const percentageMask = ['#,##', '##,##', '###,##'];
export const cpfMask = '###.###.###-##';
export const formatMaskedDecimalToNumber = (value) => {
    if (value == null || value === '')
        return null;
    if (typeof value === 'number')
        return isNaN(value) ? null : value;
    const normalized = Number(value.replace(/\./g, '').replace(',', '.'));
    return isNaN(normalized) ? null : normalized;
};
export const formatNumberToMaskedDecimal = (value) => {
    if (value == null || value === '')
        return '';
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (numericValue == null || isNaN(numericValue))
        return '';
    return numericValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
    });
};
export const formatPayloadToQueryString = (payload = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(payload).forEach(([key, value]) => {
        if (value == null || value === '')
            return;
        searchParams.append(formatCamelToSnakeCase(key), String(value));
    });
    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : '';
};
export const formatObjectToURL = (URL, params) => {
    if (!URL || !params || typeof params !== 'object')
        return;
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        searchParams.append(key, value);
    });
    return `${URL}?${searchParams.toString()}`;
};
export const formatDaysWithFallback = (days) => {
    if (typeof days === 'string')
        return days;
    if (typeof days === 'number')
        return `${days}`;
    return '-';
};
export const formatOverallProgress = (progress) => {
    const numberProgress = typeof progress === 'string' ? Number(progress) : progress;
    if (typeof numberProgress !== 'number' || isNaN(numberProgress))
        return '0.00%';
    return `${numberProgress.toFixed(2)}%`;
};
